// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__ttfoI","createCommentForm":"styles_createCommentForm__1ElVB"};